import { useEffect, useState } from 'react';
import { ExpansionPanel, EditableDenseTable } from '@/components/common';
import { useCompanyAnnualStore } from '@/store/audit/companyAnnualStore';
import type { CompanyAnnual, Shareholder } from '@/services/accountService/companyAnnualService';

type Props = {
  annualId: number;
  onChange?: (patch: Partial<CompanyAnnual>) => void;
};

export default function EpShareholding({ annualId, onChange }: Props) {
  const store = useCompanyAnnualStore();
  const [rows, setRows] = useState<Shareholder[]>([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const list = await store.getShareholdersInfo(annualId);
      if (!mounted) return;
      setRows(Array.isArray(list) ? list : []);
    })();
    return () => { mounted = false; };
  }, [annualId, store]);

  return (
    <ExpansionPanel title="Shareholding (股東)">
      <EditableDenseTable
        label=""
        head={["Shareholder's Name", "Gender"]}
        rows={(rows || []).map(b => [b.shareholderName || '', b.gender ?? 0])}
        columnKeys={["shareholderName", "gender"]}
        baseObjects={(rows || []).map(b => ({ id: (b as any).id }))}
        columnConfigs={[
          { type: 'text' },
          {
            type: 'select',
            options: [
              { label: 'Male', value: 0 },
              { label: 'Female', value: 1 },
            ],
            componentProps: { placeholder: 'Select status' },
          },
        ]}
        onRowsChangeObjects={(list) => {
          const next = (list as any[]).map((o) => ({
            id: Number(o.id ?? 0) || 0,
            shareholderName: String(o.shareholderName ?? ''),
            gender: Number(o.gender ?? 0) || 0,
          })) as Shareholder[];
          setRows(next);
          onChange?.({ shareholders: next } as Partial<CompanyAnnual>);
        }}
      />
    </ExpansionPanel>
  );
}
